export default __webpack_public_path__ + "static/media/Burger.f24bda94.svg";